import Skeleton from "@/components/loadings/skeleton/Skeleton";
import { cn } from "@/lib/utils";

function ConversationItemSkeleton() {
  return (
    <div className="flex items-center gap-3 px-4 py-3">
      <div className="size-10 shrink-0 rounded-full bg-gray-200" />
      <div className="flex flex-1 flex-col gap-2">
        <Skeleton size="sm" className="w-32" fixed={false} />
        <Skeleton size="xs" className="w-48" fixed={false} />
      </div>
      <Skeleton size="xs" className="w-8 shrink-0" fixed={false} />
    </div>
  );
}

function SidebarSkeleton() {
  return (
    <div className="flex h-full flex-col">
      <div className="flex h-20 shrink-0 items-center border-b px-4">
        <div className="flex-1">
          <Skeleton size="xl" className="w-full rounded-lg" fixed={false} />
        </div>
      </div>

      <div className="flex shrink-0 gap-1 border-b px-4 py-2">
        {[...Array(3)].map((_, i) => (
          <Skeleton
            key={i}
            size="lg"
            className="flex-1 rounded-lg"
            fixed={false}
          />
        ))}
      </div>

      <div className="flex-1 overflow-hidden">
        {[...Array(8)].map((_, i) => (
          <ConversationItemSkeleton key={i} />
        ))}
      </div>
    </div>
  );
}

function ChatAreaSkeleton() {
  return (
    <div className="flex h-full flex-col">
      <div className="flex h-20 shrink-0 items-center gap-3 border-b px-4">
        <div className="size-10 shrink-0 rounded-full bg-gray-200" />
        <div className="flex flex-1 flex-col gap-2">
          <Skeleton size="sm" className="w-36" fixed={false} />
          <Skeleton size="xs" className="w-24" fixed={false} />
        </div>
      </div>

      <div className="flex flex-1 flex-col gap-4 overflow-hidden p-4">
        <div className="flex items-end gap-2">
          <div className="size-8 shrink-0 rounded-full bg-gray-200" />
          <Skeleton size="xl" className="w-56 rounded-2xl" fixed={false} />
        </div>
        <div className="flex items-end justify-end gap-2">
          <Skeleton size="xl" className="w-40 rounded-2xl" fixed={false} />
        </div>
        <div className="flex items-end gap-2">
          <div className="size-8 shrink-0 rounded-full bg-gray-200" />
          <Skeleton size="xl" className="w-72 rounded-2xl" fixed={false} />
        </div>
        <div className="flex items-end justify-end gap-2">
          <Skeleton size="xl" className="w-52 rounded-2xl" fixed={false} />
        </div>
        <div className="flex items-end gap-2">
          <div className="size-8 shrink-0 rounded-full bg-gray-200" />
          <Skeleton size="xl" className="w-48 rounded-2xl" fixed={false} />
        </div>
        <div className="flex items-end justify-end gap-2">
          <Skeleton size="xl" className="w-64 rounded-2xl" fixed={false} />
        </div>
      </div>

      <div className="shrink-0 border-t px-3 py-4">
        <Skeleton size="2xl" className="w-full rounded-xl" fixed={false} />
      </div>
    </div>
  );
}

export default function MessengerFullscreenSkeleton() {
  return (
    <div className="flex h-full min-h-0 flex-row overflow-hidden bg-white text-sm rtl:flex-row-reverse">
      <div
        className={cn(
          "hidden min-w-0 flex-1 flex-col overflow-hidden border-e sm:flex",
        )}
      >
        <ChatAreaSkeleton />
      </div>

      <div className="sticky top-0 flex h-full w-full shrink-0 flex-col overflow-hidden border-s sm:w-sm">
        <SidebarSkeleton />
      </div>
    </div>
  );
}
